import styled from 'styled-components';
import { colors } from '../colors';

interface dropdownMenuProps {
	opacity?: string;
	display?: string;
	right?: string;
	left?: string;
	top?: string;
	bottom?: string;
	align?: string;
	open?: boolean;
}

const DropdownMenu = styled.div<dropdownMenuProps>`
	display: ${({ open }) => (open ? 'block' : 'none')};
	transition: ease-in all 0.2s;
	border: 1px solid gray;
	border-top: none;
	opacity: ${({ opacity }) => opacity};
	display: ${({ display }) => display};
	right: ${({ right }) => right};
	left: ${({ left }) => left};
	top: ${({ top }) => top};
	bottom: ${({ bottom }) => bottom};
	align: ${({ align }) => align};
	position: absolute;
	background: ${colors.White};
	border: 0px solid #dfe1e5;
	box-sizing: border-box;
	box-shadow: 1px 3px 20px rgba(0, 0, 0, 0.2);
	border-radius: 4px;
	padding: 5px 0;
	width: auto;
	z-index: 9;
	white-space: nowrap;
	right: 0;
`;

export default DropdownMenu;
